import { cmxTypeguards, commonActions, loggerFactory } from '@codametrix/ui-common';
import { AnyAction } from '@reduxjs/toolkit';
import { Action as ReduxStandardAction } from 'redux';
import { IS_PRODUCTION } from '../environment';
import { setIsActive } from '../net';
import store from '../../store/store';

const logger = loggerFactory('ParentWindowSubscriptions');

const activityEvents = new Set<string>([
  `${commonActions.AuthenticatedWindow.ACTIVITY}`
]);

const isBroadcast = (item: ReduxStandardAction) => {
  return (cmxTypeguards.isReduxAction(item) && item.meta?.broadcast) ?? false;
};

const senderSubscriptions: CMx.ChannelSubscription[] = [
  {
    match: isBroadcast
  },
  {
    observe: (item: AnyAction) => {
      isBroadcast(item) && console.log(`Broadcasting: ${item.type}`, item);
    }
  }
];

const ChildWindowActivityObserver = {
  observe: (item: ReduxStandardAction) => {
    if (cmxTypeguards.isReduxAction(item)) {
      const suppressRedux = item.meta?.suppressRedux ?? false;
      if (suppressRedux) {
        if (activityEvents.has(item.type)) {
          logger.log(`ChildWindowActivityObserver`, item);
          setIsActive(true);
        }
      } else {
        //
        if (item.meta) {
          item.meta.broadcast = false;
        }
        store.dispatch(item as ReduxStandardAction);
      }
      return false;
    }
  }
};

const receiverSubscriptions: CMx.ChannelSubscription[] = [
  ChildWindowActivityObserver
];

if (!IS_PRODUCTION) {
  receiverSubscriptions.push({
    observe: (msg: ReduxStandardAction) => {
      console.log(`message received`, msg);
    }
  });
}

export { senderSubscriptions, receiverSubscriptions };
